import { onBeforeUnmount, onMounted, ref } from 'vue';

export function useReducedMotion() {
    const reducedMotion = ref(false);
    let motionQuery: MediaQueryList | null = null;
    let updateMotionPreference: (() => void) | null = null;

    onMounted(() => {
        motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        updateMotionPreference = () => {
            reducedMotion.value = motionQuery?.matches ?? false;
        };
        updateMotionPreference();
        motionQuery.addEventListener('change', updateMotionPreference);
    });

    onBeforeUnmount(() => {
        if (motionQuery && updateMotionPreference) {
            motionQuery.removeEventListener('change', updateMotionPreference);
        }
    });

    return { reducedMotion };
}
